const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TILE = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}";
const UKEY = "mwcrm_map_mode";
const HKEY = "mw_home_map_mode";
const tok = () => localStorage.getItem("mwcrm_token");
const req = (path, opt = {}) => fetch(API + path, { ...opt, headers: { "Content-Type": "application/json", ...(tok() ? { Authorization: `Bearer ${tok()}` } : {}) } });
let geoP = null;
const geo = () => (geoP = geoP || fetch("/tr-iller.json").then((r) => r.json()));
let meP = null;
const me = () => (meP = meP || (tok() ? req("/auth/me").then((r) => (r.ok ? r.json() : null)).catch(() => null) : Promise.resolve(null)));

function applyMode(map, st, mode) {
  const L = window.L;
  if (st.mode === mode || st.dead) return;
  st.mode = mode;
  if (st.tile) { map.removeLayer(st.tile); st.tile = null; }
  if (st.digi) { map.removeLayer(st.digi); st.digi = null; }
  const box = map.getContainer();
  if (mode !== "digital") {
    box.style.background = "";
    st.tile = L.tileLayer(TILE, { maxZoom: 18 }).addTo(map);
    st.tile.bringToBack();
  } else {
    box.style.background = "#020617";
    geo().then((g) => {
      if (st.mode !== "digital" || !map._loaded || st.dead) return;
      const rnd = L.canvas({ padding: 0.5 });
      const grp = L.layerGroup();
      const shapes = L.geoJSON(g, { interactive: false, renderer: rnd, style: { color: "#22d3ee", weight: 1.2, opacity: 0.9, fill: false } });
      grp.addLayer(shapes);
      shapes.eachLayer((ly) => {
        const name = String(ly.feature?.properties?.name || "").toLocaleUpperCase("tr-TR");
        const icon = L.divIcon({ className: "", iconSize: [90, 12], iconAnchor: [45, 6], html: `<div style="text-align:center;font:700 9px/12px ui-monospace,monospace;color:#67e8f9;letter-spacing:.5px;text-shadow:0 0 4px #0891b2;white-space:nowrap;pointer-events:none">${name}</div>` });
        grp.addLayer(L.marker(ly.getBounds().getCenter(), { icon, interactive: false, keyboard: false }));
      });
      grp.addTo(map);
      shapes.bringToBack();
      if (rnd._container) rnd._container.style.pointerEvents = "none";
      st.digi = grp;
    }).catch(() => {});
  }
  if (st.btn) st.btn.textContent = mode === "digital" ? "💠 DİJİTAL HARİTA" : "🗺 STANDART HARİTA";
}

function button(text, testid) {
  const b = window.L.DomUtil.create("button", "");
  b.type = "button";
  b.textContent = text;
  b.setAttribute("data-testid", testid);
  b.style.cssText = "display:block;margin-top:4px;background:#fff;border:2px solid rgba(0,0,0,.25);border-radius:6px;padding:4px 8px;font:800 11px/1.2 inherit;color:#0f172a;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,.25)";
  window.L.DomEvent.disableClickPropagation(b);
  return b;
}

export function addBaseMap(map, key) {
  const L = window.L;
  const st = { mode: null };
  map.on("unload", () => { st.dead = true; });
  if (key === "home" || key === "network") {
    applyMode(map, st, localStorage.getItem(HKEY) || "standard");
    fetch(API + "/public/home-map-mode").then((r) => r.json()).then((d) => { localStorage.setItem(HKEY, d.mode); if (map._loaded) applyMode(map, st, d.mode); }).catch(() => {});
    return;
  }
  applyMode(map, st, localStorage.getItem(UKEY) || "standard");
  const wrap = L.DomUtil.create("div", "");
  st.btn = button("", `map-mode-${key}`);
  st.btn.textContent = st.mode === "digital" ? "💠 DİJİTAL HARİTA" : "🗺 STANDART HARİTA";
  st.btn.onclick = () => {
    const m = st.mode === "digital" ? "standard" : "digital";
    localStorage.setItem(UKEY, m);
    applyMode(map, st, m);
    req("/me/map-mode", { method: "PUT", body: JSON.stringify({ data: { mode: m } }) }).catch(() => {});
  };
  wrap.appendChild(st.btn);
  me().then((u) => {
    if (!u) return;
    if (u.map_mode && u.map_mode !== localStorage.getItem(UKEY)) { localStorage.setItem(UKEY, u.map_mode); if (map._loaded) applyMode(map, st, u.map_mode); }
    if (u.role !== "super_admin") return;
    const hb = button("🏠 ANA SAYFAYA UYGULA", `map-home-apply-${key}`);
    hb.onclick = () => req("/home-map-mode", { method: "PUT", body: JSON.stringify({ data: { mode: st.mode } }) })
      .then((r) => { if (r.ok) { localStorage.setItem(HKEY, st.mode); hb.textContent = `✓ ANA SAYFA: ${st.mode === "digital" ? "DİJİTAL" : "STANDART"}`; } });
    wrap.appendChild(hb);
  });
  const Ctl = L.Control.extend({ options: { position: "topright" }, onAdd: () => wrap });
  map.addControl(new Ctl());
}
